

















































































import Vue from "vue";
import eventBus from "@/services/eventBus";
import paginate from "jw-paginate";
import createPagerText from "@/utils/pagerText";
import { PaginatedPager } from "@/models/Pager";

interface Data {
  pager: PaginatedPager;
  /** Visszatöltött oldal, amire az első adatbetöltés után kell ráállni (1-nél nagyobb kezdőoldal). */
  pendingRestorePage: number | null;
}

interface Methods {
  setPage(page: number, size?: number): void;
  setPageSize(size: number): void;
}

interface Props {
  baseSizes: number[];
  totalItems: number;
  /** Kezdő oldal (pl. navigáció után visszatöltött állapotból) - @default 1 */
  initialPage: number;
  /** Kezdő lapméret - @default 0 (= baseSizes[0]) */
  initialPageSize: number;
  /** A léptető gombok színe (az ApiSearchPage színét kapja) - @default "primary" */
  color: string;
}

//
//!  Usage -> pl. ApiSearch.vue
//
//  @change - returns the pager object with the currentPage, pageSize
//
//? <template>
//    <ApiPaginator @change="pagerChanged"
//                  :totalItems="totalItems"
//                  :baseSizes="baseSizes" />
//

export default Vue.extend<Data, Methods, {}, Props>({
  props: {
    baseSizes: {
      type: Array as () => number[],
      default: () => [10, 25, 50, 100],
    },

    totalItems: {
      type: Number,
      default: 0,
    },

    initialPage: { type: Number, default: 1 },
    initialPageSize: { type: Number, default: 0 },
    color: { type: String, default: "primary" },
  },

  data: () => ({
    pager: new PaginatedPager(),
    pendingRestorePage: null as number | null,
  }),

  created() {
    this.pager = new PaginatedPager({ totalItems: this.totalItems, currentPage: this.initialPage });
    // Az 1-nél nagyobb kezdőoldalra csak az első adatbetöltés (totalItems)
    // megérkezése után lehet ráállni — addig a paginate() 0 oldalra clampelne.
    this.pendingRestorePage = this.initialPage > 1 ? this.initialPage : null;
    eventBus.$on("api-pager:set-page", this.setPage);
  },

  beforeMount() {
    this.setPage(this.initialPage, this.initialPageSize || this.baseSizes[0]);
  },

  beforeDestroy() {
    eventBus.$off("api-pager:set-page", this.setPage);
  },

  methods: {
    setPage(page, size) {
      this.pager = size
        ? paginate(this.totalItems, page, size, 5)
        : paginate(this.totalItems, page, this.pager.pageSize, 5);

      this.$emit("change", this.pager);
    },

    setPageSize(size) {
      this.pager.pageSize = size;
      this.setPage(1, size);
    },
  },

  watch: {
    totalItems() {
      // Visszatöltött kezdőoldal: az első adatbetöltés után arra állunk rá
      // a szokásos 1. oldalra ugrás helyett (a lista már ezt az oldalt kérte le).
      if (this.pendingRestorePage) {
        const page = this.pendingRestorePage;
        this.pendingRestorePage = null;
        this.setPage(page);
        return;
      }

      if (this.pager.currentPage > 1 && this.pager.pageSize !== this.baseSizes[0]) {
        this.setPageSize(this.baseSizes[0]);
      } else {
        this.setPage(1);
      }
    },
  },

  computed: {
    footerText() {
      return createPagerText(this.totalItems, this.pager.currentPage, this.pager.pageSize);
    },
  },
});
